import styled from "styled-components";

export const PageContent = styled("div")`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: #ffffff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
`;
